let Menu           = require('./Menu');

class MenuVertical extends Menu {
    constructor(className = '') {
        super(className);
        this._container = document.getElementsByClassName('js-pagination')[0];

        let sections = Array.from(document.querySelectorAll("main > section"));
        sections.splice(0, 1);
        this._createLi(sections, 1);

        this._header = document.getElementsByTagName('header')[0];
    }

    init() {
        super.init();

        this._setDisplay();

        this._scrollSpy.addListener(() => {
            let mouse = document.querySelector('.js-mouse');
            if (this._scrollSpy.getAnchorsIndex() === this._links.length - 1 && this._container.style.position !== 'absolute') {
                this._container.style.position = 'absolute';

                const TOP = window.scrollY + this._scrollSpy.getCurrentSection().getBoundingClientRect().top - this._scrollSpy.getOffset();

                this._container.style.top = TOP + 'px';
                // document.body.style.overflow = 'auto';
                mouse.style.display       = 'none';
            } else if (this._scrollSpy.getAnchorsIndex() < this._links.length - 1 && this._container.style.position === 'absolute') {
                this._container.style.position = '';
                this._container.style.top      = '';
                // document.body.style.overflow   = '';
                mouse.style.display            = '';
            }

            this._setDisplay();
        });
    }

    _createLi(sections, index) {
        for (let section of sections) {
            if (this._containSection(section)) {
                index = this._createLi(section.getElementsByTagName("section"), index)
            } else {
                let li       = document.createElement('li');
                li.innerText = index < 10 ? '0' + index : index;

                li.setAttribute('data-target', '#' + section.id);

                this._links.push(li);

                this._container.append(li);

                index++;
            }
        }

        return index;
    }

    _setDisplay() {
        if (this._links[0].classList.contains('active') || this._linksActive()) {
            this._header.classList.remove('transparent');
            this._container.style.display = 'flex';
        } else if (!this._linksActive()) {
            this._header.classList.add('transparent');
            this._container.style.display = 'none';
        }
    }

    _linksActive() {
        let isActiveItem = false;

        for (let link of this._links) {
            if (link.classList.contains('active')) {
                isActiveItem = true;
            }
        }

        return isActiveItem;
    }

    _containSection(node) {
        for (let child of node.children) {
            if (child.nodeName === 'SECTION') {
                return true;
            }
        }

        return false;
    }
}

module.exports = MenuVertical;